import {ZIDX, ZIDXPage} from "../standaloneLibrary.js";
import jQuery from 'jquery';
let $=jQuery.noConflict();

export class ZIDXResults implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxResultsContainer";
    }
    render(){
        // console.log("results");
        $(".zidxSiteHomeContainer", this.zidx.peakidxShadowRoot).remove();
        // if($(".zidxRedirectToSiteHome", this.zidx.peakidxShadowRoot).length>0){
        //     this.zidx.loadPushStateURL(this.zidx.getPrefixURL("/"), false);
        // }
        // else{
        //     let url=new URL(window.location.href);
        //     let h=url.searchParams.get("h");
        //     if(!h || h==""){
        //         h=""+new Date().getTime();
        //     }
        //     let parts=window.location.href.split("?");
        //     if(parts.length>1) {
        //         window.history.replaceState({}, document.title, parts[0]+"?h="+h);
        //     }
        // }
        this.zidx.zidxBase.resetForNavigation();
        this.zidx.zidxMap.mode="markers";
        this.zidx.zidxBase.init(true, false, true, true)
    }
}